var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1125_1030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.666 16.6667H6.66602V28.3334H11.666V16.6667Z",
    fill: "url(#paint0_linear_1125_1030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.6667H17.5V28.3334H22.5V16.6667Z",
    fill: "url(#paint1_linear_1125_1030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 31.6667H3.33301V36.6667H36.6663V31.6667Z",
    fill: "url(#paint2_linear_1125_1030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333 16.6667H28.333V28.3334H33.333V16.6667Z",
    fill: "url(#paint3_linear_1125_1030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 1.66675L3.33301 10.0001V13.3334H36.6663V10.0001L19.9997 1.66675Z",
    fill: "url(#paint4_linear_1125_1030)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1125_1030",
    x1: 9.16602,
    y1: 16.6667,
    x2: 9.16602,
    y2: 28.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1125_1030",
    x1: 20,
    y1: 16.6667,
    x2: 20,
    y2: 28.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1125_1030",
    x1: 19.9997,
    y1: 31.6667,
    x2: 19.9997,
    y2: 36.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1125_1030",
    x1: 30.833,
    y1: 16.6667,
    x2: 30.833,
    y2: 28.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1125_1030",
    x1: 19.9997,
    y1: 1.66675,
    x2: 19.9997,
    y2: 13.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1125_1030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bankIcon.b811bcfc96860691f3fc1ce7d6863e51.svg";
export { ForwardRef as ReactComponent };